
export default function EquipmentNavService(gettext) {

    'ngInject';

    var module = {
        "id": "equipment",
        "name": gettext("Assets"),
        "sref": "equipment",
        "icon": "icon-can",
        "priority": 90
    };

    this.getModule = function () {
        return module;
    };

}
